import React, { useEffect, useState } from 'react'
import { auth, db } from '../../../services/firebase'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import { doc, setDoc, serverTimestamp, getDoc } from 'firebase/firestore'
import LoadingSpinner from '../../../components/common/LoadingSpinner'

function SeedAdminPage() {
  const [status, setStatus] = useState('pending')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const run = async () => {
      try {
        const email = import.meta.env.VITE_SEED_ADMIN_EMAIL
        const password = import.meta.env.VITE_SEED_ADMIN_PASSWORD
        if (!email || !password) {
          setStatus('error')
          setMessage('Faltan variables VITE_SEED_ADMIN_EMAIL y VITE_SEED_ADMIN_PASSWORD')
          return
        }
        const cred = await createUserWithEmailAndPassword(auth, email, password)
        await setDoc(doc(db, 'users', cred.user.uid), {
          uid: cred.user.uid,
          displayName: 'Administrador',
          email,
          role: 'admin',
          plan: 'premium',
          active: true,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        })
        setStatus('done')
        setMessage('Administrador creado correctamente')
      } catch (e) {
        if (e.code === 'auth/email-already-in-use') {
          setStatus('done')
          setMessage('El admin ya existe')
        } else {
          setStatus('error')
          setMessage(e.message)
        }
      }
    }
    run()
  }, [])

  if (status === 'pending') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white rounded-xl shadow p-6 max-w-md w-full text-center">
        <h1 className="text-xl font-semibold mb-2">Seed Admin</h1>
        <p className={status === 'error' ? 'text-red-600' : 'text-green-600'}>{message}</p>
      </div>
    </div>
  )
}

export default SeedAdminPage
